import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Pagination, Row } from "react-bootstrap";
import OwlCarousel from "react-owl-carousel";
import live_session_img1 from '../../../assets/images/dummy/live_session_img1.png';
import dummy_coach1_sqr from '../../../assets/images/dummy/dummy_coach1_sqr.png';
import mental_coach from '../../../assets/images/dummy/mental_coach.png';
import { NavLink, useNavigate } from "react-router-dom";
import BlogModalComponent from "./blog_details";
import { getAllBlogs, allCategories, allAuthor } from "../../../utils/api";
import send_wht from "../../../assets/images/icons/send_wht.png";
import quote_grn from '../../../assets/images/icons/quote_grn.png';
import blog_card_img1 from "../../../assets/images/dummy/blog_card_img1.png";
import testimonials_img1 from "../../../assets/images/dummy/testimonials_img1.png";
import noblogs from "../../../assets/images/no-blogs.png";
// import { allCategories } from './../../../utils/api/index';
import { PulseLoader } from "react-spinners";
import { Helmet } from "react-helmet";

function AllBlogsComponent() {
  const navigate = useNavigate();
    var count = 0;
    var counter = 0;
    const [allBlogs, setAllBlogs] = useState([]);
    const [latestBlogs, setLatestBlogs] = useState([]);
    const [alltestimonial, setTestimonials] = useState([]);
    const [allSelectedCate, setAllSelectedCate] = useState([]);
    const [featuredBlogs, setFeaturedBlogs] = useState([]);
    const [popularBlogs, setPopularBlogs] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectAuthors, setSelectAuthors] = useState([]);
    const [authorList, setAuthorList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [contentloading, setContentLoading] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10); // Blogs per page
    const [totalBlogs, setTotalBlogs] = useState(0); // Total count from API

    function getDate(time) {
        const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Octr",
            "Nov",
            "Dec",
        ];

        const date = new Date(time).getDate();
        const year = new Date(time).getFullYear();
        const month = months[new Date(time).getMonth()];

        let hour = new Date(time).getHours();
        let minute = new Date(time).getMinutes();

        const am_pm = hour > 12 ? "PM" : "AM";
        const time_string = `${date} ${month} ${year}`;
        return time_string;
    }

    useEffect(() => {
        const canonicalUrl = window.location.origin + window.location.pathname;
        let link = document.querySelector("link[rel='canonical']");
        if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
        }
        link.setAttribute('href', canonicalUrl);

        getData();
        window.scrollTo(0, 0);
    }, [])

    const getData = async () => {
        let allSelectedCate = "";
        filterCate(allSelectedCate);
        const allcat = await allCategories();
        if (allcat) {
            console.log(allcat.data.data);
            setCategories(allcat.data.data)
        }
        const allAuthors = await allAuthor();
        if (allAuthors) {
            setAuthorList(allAuthors.data.data);
            console.log(allAuthors.data.data, 'allAuthor');
        }
        setLoading(false)
    }

    const [blogModalShow, setBlogModalShow] = React.useState(false);
    const [singleBlogDetails, setSingleBlogDetails] = React.useState('');
    const showModal = (e, blog) => {
        setBlogModalShow(true)
        setSingleBlogDetails(blog)
    }

    const removeHTMLTags = (str) => {
        return str.replace(/<[^>]+>/g, ''); // Remove HTML tags
    };
    const defaultUserImage = (e) => {
        // e.target.src = 'https://api.vaffix.com/uploads/images/avatar_dummy.webp';
        e.target.src = blog_card_img1;
    }
    const defaultImage = (e) => {
        e.target.src = blog_card_img1;//'https://admin.qoach.io/assets/images/blog.png';
    }
    const selectCate = (e) => {
        const index = allSelectedCate.indexOf(e.target.value);
        if (index !== -1) {
            allSelectedCate.splice(index, 1);
        } else {
            allSelectedCate.push(e.target.value);
        }
        console.log(allSelectedCate);
        filterCate(allSelectedCate, 'category');
        setAllSelectedCate(allSelectedCate);
    }
    const selectAuthor = (e) => {
        const selectedAuthor = e.target.value;

        // First, update the selected author state
        setSelectAuthors(selectedAuthor);

        // Ensure the filter applies correctly with the latest state
        filterCate(selectedAuthor, 'author');
    };

    /*const filterCate = async (list, type) => {
        //setLoading(true); // Show loader before API call
        const formData = new FormData();

        if (list !== "") {
            formData.append('author', list);
        } else {
            formData.append('author', selectAuthors);
        }

        try {
            const { data } = await getAllBlogs(formData);
            console.log("API Response: ", data); // Check API response in console
            if (data?.data) {
                setAllBlogs(data.data.data.all);
                setLatestBlogs(data.data.data.latest);
                setFeaturedBlogs(data.data.data.featured);
                setPopularBlogs(data.data.data.popular);
                setTestimonials(data.data.testimonial);
            }
        } catch (error) {
            console.error("Error fetching filtered data:", error);
        } finally {
            setLoading(false); // Hide loader after API call
        }
    };*/

    /*const selectAuthor = (e) => {
        filterCate(e.target.value, 'author');
    }*/

    /////////////////////////////////////////////////////////
    const filterCate = async (list, type, page = 1) => {
        setContentLoading(true);
        const formData = new FormData();

        if (list !== "") {
            if (type === "category") {
                const modifiedStrings = list.map(str => str.replace("cate", ""));
                formData.append("categories", modifiedStrings.join(","));
            } else {
                formData.append("categories", allSelectedCate.map(str => str.replace("cate", "")).join(","));
            }
            if (type === "author") {
                formData.append("author", list);
            } else {
                formData.append("author", selectAuthors);
            }
        }

        formData.append("type", 'all');

        // Send pagination parameters (start & length)
        formData.append("start", (page - 1) * pageSize);
        formData.append("length", pageSize);

        const data = await getAllBlogs(formData);
        if (data.data && data.data.data) {
            setAllBlogs(data.data.data.all);
            setTotalBlogs(data.data.pagination.totalBlogs); // Get total blog count from API
        }
        setContentLoading(false);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        filterCate(allSelectedCate, "category", page);
    };

    /////////////////////////////////////////////////////////

    const scrollLeft = () => {
        const container = document.getElementById('filterScroll');
        container.scrollLeft -= 100;
    }
    const scrollRight = () => {
        const container = document.getElementById('filterScroll');
        container.scrollLeft += 100;
    }
    return (
        <>
            <Helmet
                htmlAttributes={{ lang: 'en' }}
                title="Explore Insights and Wisdom | Qoach Blog Hub"
                meta={[
                    { name: 'description', content: "Discover a treasure trove of insights and wisdom from our expert coaches. Dive into our blog hub to gain valuable knowledge and inspiration on personal growth, career advancement, wellness, and more. Start your journey of discovery with Qoach today!" },
                ]}
            />
            {loading ? (
                // <PulseLoader color="#36D7B7" loading={loading} size={15} />
                <div
                    style={{
                        // textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100vh",
                        width: "100vw",
                    }}
                >
                    <p>
                        <PulseLoader color="#00504E" size={20} />
                    </p>
                </div>
            ) : (
                <>
                    <section className="position-relative py-5" style={{background: 'rgba(0, 80, 78, 0.1)'}}>
                        <Container>
                            <Button className="position-relative px-3" variant="page_back" onClick={() => navigate(-1)} style={{zIndex: '2'}} >
                                <svg className="me-3" width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.3965 1.49949C12.3961 1.89718 12.2379 2.27846 11.9565 2.55949L4.28448 10.2315C4.05227 10.4636 3.86806 10.7393 3.74238 11.0426C3.6167 11.346 3.55202 11.6711 3.55202 11.9995C3.55202 12.3279 3.6167 12.653 3.74238 12.9564C3.86806 13.2597 4.05227 13.5353 4.28448 13.7675L11.9465 21.4345C12.2197 21.7174 12.3709 22.0963 12.3675 22.4896C12.3641 22.8829 12.2063 23.2591 11.9282 23.5372C11.6501 23.8153 11.2739 23.9731 10.8806 23.9765C10.4873 23.9799 10.1084 23.8287 9.82548 23.5555L2.16348 15.8945C1.13325 14.8622 0.554641 13.4634 0.554641 12.005C0.554641 10.5466 1.13325 9.14776 2.16348 8.11549L9.83548 0.443495C10.045 0.233877 10.3118 0.0910072 10.6024 0.0329132C10.893 -0.0251808 11.1943 0.00410271 11.4683 0.117071C11.7423 0.23004 11.9766 0.421629 12.1418 0.667664C12.307 0.913698 12.3956 1.20315 12.3965 1.49949Z" fill="#14183E"></path>
                                </svg>
                                Back
                            </Button>
                        </Container>
                        <Container fluid className="blog_page_bnr_cntnt">
                            <Row className="justify-content-center">
                                <Col lg="12">
                                    <div className="poppins_fnt">
                                        <h3 className="">All Blogs</h3>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    <section className="blog-filter my-5">
                        <Container>
                            <Row>
                                <div className="col-12">
                                    <div className="d-flex align-items-start justify-content-between filter-buttons">
                                        {/* <div className="d-flex align-items-start justify-content-between cate-filter"> */}
                                        <button onClick={scrollLeft} className="prev-btn bg-transparent ps-2 pe-4">
                                            <svg width="20px" height="20px" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16.1795 3.26875C15.7889 2.87823 15.1558 2.87823 14.7652 3.26875L8.12078 9.91322C6.94952 11.0845 6.94916 12.9833 8.11996 14.155L14.6903 20.7304C15.0808 21.121 15.714 21.121 16.1045 20.7304C16.495 20.3399 16.495 19.7067 16.1045 19.3162L9.53246 12.7442C9.14194 12.3536 9.14194 11.7205 9.53246 11.33L16.1795 4.68297C16.57 4.29244 16.57 3.65928 16.1795 3.26875Z" fill="#964b00" />
                                            </svg>
                                        </button>
                                        <div className="d-flex overflow-x-scroll mx-2" id="filterScroll">
                                            {
                                                categories && categories.length > 0 ?
                                                    categories.map((post) => (
                                                        <div>
                                                            <input type="checkbox" className="d-none" id={`cate` + post.id} name={`cate` + post.id} value={`cate` + post.id} onClick={(e) => selectCate(e)} />
                                                            {
                                                                allSelectedCate.includes(`cate` + post.id) === true ?
                                                                    <>
                                                                        <label for={`cate` + post.id} className='me-2 active' >{post.name}</label>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <label for={`cate` + post.id} className='me-2 checkbox-btn'>{post.name}</label>
                                                                    </>
                                                            }
                                                        </div>
                                                    ))
                                                    : ''
                                            }
                                        </div>
                                        <button onClick={scrollRight} className="next-btn bg-transparent ps-2 pe-4">
                                            <svg width="20px" height="20px" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.82054 20.7313C8.21107 21.1218 8.84423 21.1218 9.23476 20.7313L15.8792 14.0868C17.0505 12.9155 17.0508 11.0167 15.88 9.84497L9.3097 3.26958C8.91918 2.87905 8.28601 2.87905 7.89549 3.26958C7.50497 3.6601 7.50497 4.29327 7.89549 4.68379L14.4675 11.2558C14.8581 11.6464 14.8581 12.2795 14.4675 12.67L7.82054 19.317C7.43002 19.7076 7.43002 20.3407 7.82054 20.7313Z" fill="#964b00" />
                                            </svg>
                                        </button>
                                        {/* </div> */}
                                        <div className="ms-2 px-3 auther-filter d-block">
                                            <select
                                                name="author"
                                                id="author"
                                                className="bg-transparent border-0"
                                                value={selectAuthors}
                                                onChange={(e) => {
                                                    setSelectAuthors(e.target.value);
                                                    filterCate(e.target.value, "author"); // Ensure API call happens
                                                }}
                                                >
                                                <option value="">Select Author</option>
                                                {authorList.map((element) => (
                                                    <option key={element.id} value={element.id}>
                                                        {element.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="mt-4 select-auther-filter d-none">
                                        <div className="ms-2 px-3  auther-filter d-inline">
                                            <select
                                                name="author"
                                                id="author"
                                                className="bg-transparent border-0 d-inline"
                                                value={selectAuthors}
                                                onChange={(e) => {
                                                    setSelectAuthors(e.target.value);
                                                    filterCate(e.target.value, "author"); // Ensure API call happens
                                                }}
                                                >
                                                <option value="">Select Author</option>
                                                {authorList.map((element) => (
                                                    <option key={element.id} value={element.id}>
                                                        {element.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </Row>
                        </Container>
                    </section>
                    {contentloading ? (
                        <div
                            style={{
                                // textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100vh",
                                width: "100vw",
                            }}
                        >
                            <p>
                                <PulseLoader color="#00504E" size={20} />
                            </p>
                        </div>
                    ) : (
                        <>
                        <div>
                        {
                            allBlogs ? allBlogs.length > 0 ?
                            <section className="most_popular">   
                                <Container>
                                    <Row>
                                        {
                                            allBlogs.map((blog, index) => {
                                                count = index + 1
                                                blog.content = (blog.content).replace(/<[^>]+>/g, '')
                                                blog.content = (blog.content).replace(/&nbsp;/g, ' ');
                                                return (
                                                    <Col sm="6" lg="4" className="mb-4">
                                                        <NavLink className="text_brand_color8 fw-500 fs-14" to={`/blog-details/${blog.slug}`}>
                                                            <div className="blog_card border rounded-4 h-100 overflow-hidden">
                                                                <div className="blog_card_img">
                                                                    {blog.image ? (
                                                                        <img alt="" className="w-100" src={`${process.env.REACT_APP_SOCKET_URL}/upload/cab/resized/${blog.image}`} onError={(e) => defaultImage(e)} />
                                                                    ) : (
                                                                        <img alt="" className="w-100" src={blog_card_img1} onError={(e) => defaultImage(e)} />
                                                                    )}
                                                                </div>
                                                                <div className="blog_card_body px-3">
                                                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                                                        <div className="d-flex align-items-center">
                                                                            {blog.profile_pic ? (
                                                                                <img
                                                                                    width={30}
                                                                                    height={30}
                                                                                    alt=""
                                                                                    className="user_img rounded-circle me-2"
                                                                                    src={`${process.env.REACT_APP_SOCKET_URL}/upload/users/profile/${blog.profile_pic}`}
                                                                                    style={{ borderRadius: '50%' }}
                                                                                    onError={(e) => defaultUserImage(e)}
                                                                                />
                                                                            ) : (
                                                                                <img
                                                                                    width={30}
                                                                                    height={30}
                                                                                    alt=""
                                                                                    className="user_img me-2"
                                                                                    src={testimonials_img1}
                                                                                />
                                                                            )}

                                                                            <h5 className="m-0 fs-18">{blog.name ? blog.name : 'Qoach'}</h5>
                                                                        </div>

                                                                        <span className="fs-12 fw-500 opacity_7">
                                                                            {getDate(
                                                                                blog.blog_date !== null
                                                                                    ? blog.blog_date
                                                                                    : blog.updated_at
                                                                            )}
                                                                        </span>
                                                                    </div>
                                                                    <h5 className="m-0 mt-2 mb-1 fs-18 fw-500 truncate-two-lines"> {blog?.title} </h5>
                                                                    <p className="fs-14 fw-300 opacity_7 mb-3">
                                                                        {/* {removeHTMLTags(blog.content).substring(0, 125)}... */}
                                                                        {removeHTMLTags(blog.content)}
                                                                    </p>
                                                                    <NavLink className="text_brand_color8 fw-500 fs-14" to={`/blog-details/${blog.slug}`}>Read More</NavLink>
                                                                </div>
                                                            </div>
                                                        </NavLink>
                                                    </Col>
                                                )
                                            })
                                            // : ''
                                        }
                                    </Row>
                                </Container>
                                <Container>
                                    <Pagination className="justify-content-center">
                                        <Pagination.Prev 
                                            onClick={() => handlePageChange(currentPage - 1)}
                                            disabled={currentPage === 1}
                                        />

                                        {totalBlogs > 0 && !isNaN(totalBlogs) ? (
                                            [...Array(Math.ceil(totalBlogs / pageSize))].map((_, index) => (
                                                <Pagination.Item 
                                                    key={index + 1} 
                                                    active={index + 1 === currentPage} 
                                                    onClick={() => handlePageChange(index + 1)}
                                                >
                                                    {index + 1}
                                                </Pagination.Item>
                                            ))
                                        ) : (
                                            <Pagination.Item disabled>No Data</Pagination.Item>
                                        )}

                                        <Pagination.Next 
                                            onClick={() => handlePageChange(currentPage + 1)}
                                            disabled={currentPage === Math.ceil(totalBlogs / pageSize)}
                                        />
                                    </Pagination>
                                </Container>
                            </section>                                        
                            : ''
                            : ''
                        }
                        {
                            allBlogs && allBlogs.length === 0 ?
                            <Container>
                                {/*<div className="my-5 py-5">
                                    <p className="text-center">Blog not found</p>
                                </div>*/}
                                <div className="text-center">
                                    <img src={noblogs} alt="no blogs" />
                                    <p>No Blog found related to search criteria!</p>
                                </div>                                    
                            </Container>
                            :
                            ""
                        }
                        </div>
                    </>                                                 
                    )}                                                    
                </>
            )
            }
        </>
    )
}

export default AllBlogsComponent;